import {useMutation} from '@tanstack/react-query';
import {updateContactDataCache} from 'presentation/queries/useContactDataQuery/utils/updateContactDataCache';
import {postChangeAddress} from '../../services/postChangeAddress';
import {useChangeDataAlertStore} from '../../store/changeDataAlertStore';
import {useChangeDataFormStateStore} from '../../store/changeDataFormStateStore';
import {MessageEnum, AlertEnum} from '../../store/changeDataAlertStore/types';
import {AccordionStateEnum} from '../../store/formAccordionStore/types';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';
import {useGetProgressQuery} from '../useGetProgressQuery';
import {useRegistrationUpdateStatusStore} from 'presentation/pages/private/store/useRegistrationUpdateStatusStore';
import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

export function useChangeAddressMutation() {
	const setChangeDataFormState = useChangeDataFormStateStore(state => state.updateFormState);
	const setChangeDataAlertState = useChangeDataAlertStore(state => state.setStatus);

	const {setNeedsUpdate} = useRegistrationUpdateStatusStore();
	const {refetch} = useGetProgressQuery();

	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	return useMutation({
		mutationFn: postChangeAddress,
		onSuccess: data => {
			updateContactDataCache({
				endereco: {
					nmUf: data.nmUf,
					nmCidade: data.nmCidade,
					nmBairro: data.nmBairro,
					nmTipoLogradouro: data.nmTipoLogradouro,
					nmRua: data.nmRua,
					nuEndereco: data.nuEndereco,
					nuCep: data.nuCep,
					dsComplemento: data.dsComplemento,
				},
			});

			if (isNewProfileFeatureFlagEnabled) {
				refetch();
			}

			setChangeDataAlertState({
				type: AlertEnum.ADDRESS,
				typeMessage: MessageEnum.SUCCESS,
				status: true,
			});

			queryClient.setQueryData([QUERY_KEYS.REGISTRATION_UPDATE_STATUS], {
				necessitaAtualizacao: false,
			});
			setNeedsUpdate(false);
		},
		onError: () => {
			setChangeDataAlertState({
				type: AlertEnum.ADDRESS,
				typeMessage: MessageEnum.ERROR,
				status: true,
			});
		},
		onSettled: () => {
			setChangeDataFormState({
				name: AccordionStateEnum.ADDRESS,
				isFormDirty: false,
				isFormActive: isNewProfileFeatureFlagEnabled,
			});
		},
	});
}
